export default [
    //FOR FINANCE MANAGER===============================================================================

    {
        subject: "roles",
        key: "role",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "PO Pending For Approval",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",
            }, {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            },

        ]

    },


]